<template>
  <div
    class="video-box"
    ref="phone">
    <div
      class="phone"
      v-if="isMobilePhone">
      <div
        class="top-loading"
        ref="topLoadingElem"
        v-if="topPulling">
        <img
          src="../common/img/loading.gif"
          class="loadingImg"
          alt>
      </div>
      <div
        class="pageLoading"
        v-if="pageLoading">
        <div class="load-icon"/>
      </div>
      <div class="video-style">
        <div
          class="video-tabs"
          ref="videoTabs">
          <scroll
            class="cards_box"
            ref="scroll"
            :data="tabList">
            <!-- <div class="video-tabs-wrapper"> -->
            <ul
              class="box"
              ref="box">
              <li
                @click="getChannel(item, index)"
                v-for="(item, index) in tabList"
                :key="index">
                <span :class="{'active': index === activeIndex}">{{ item.name }}</span>
              </li>
            </ul>
            <!-- </div> -->
          </scroll>
        </div>
        <div
          class="video-list"
          v-if="tabLoaded && !pageLoading"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
          @touchend="onTouchEnd"
          :style="{ transform: topLoading || topPulling ? 'translateY(' + topPullDistance + 'px)' : 'none'}"
        >
          <div
            class="list-item"
            v-for="(i, index) in videoList"
            :key="index">
            <videoItem :video-item="i"/>
          </div>
        </div>
        <div
          id="police_beiang"
          v-if="!pageLoading">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202001456"
            style="display:inline-block;text-decoration:none;"
          >
            <img
              src="../img/icon_police.png"
              style="float:left;">
            <p style="float:left;color:#939393;">浙公网安备 33010202001456号</p>
          </a>
        </div>

        <!-- <div class="bottom-loading" v-if="isLoading"><img src="../common/img/loading.gif" class="loadingImg" alt=""></div> -->
      </div>
      <div @click="dadian">
        <GuideBanner
          v-if="isHeytapPhone"
          :is-show-tip="isShowTip"
          @show="_showGuide"/>
      </div>
      <div
        class="open-guide"
        v-if="showGuide">选择浏览器打开,下载视频APP,观看更多精彩视频</div>
    </div>

    <div
      class="pc-style"
      v-else>
      <div
        class="top-wrap"
        monkey="baiduhaokan-pcdl">
        <div class="top">
          <div class="phone-wrap animated fadeInLeft">
            <img
              class="phoneIcon"
              src="../common/img/phone.png">
            <!-- <div class="screen-wrap"><img class="screen" src="file:///D:/%E4%B8%8B%E8%BD%BD/aaaa/%E5%A5%BD%E7%9C%8B%E8%A7%86%E9%A2%91%EF%BC%8C%E7%9C%8B%E8%A7%86%E9%A2%91%E9%A2%86%E7%8E%B0%E9%87%91_files/lunbo5_eea12bf.jpg"
            width="275" height="488"></div>-->
            <div class="feature zhuye">
              <div class="zhuye-y">
                <div class="feature-icon zhuye-icon animated zoomIn"/>
              </div>
            </div>
            <div class="feature guanzhu">
              <div class="guanzhu-y">
                <div class="feature-icon guanzhu-icon animated zoomIn"/>
              </div>
            </div>
            <div class="feature wode">
              <div class="wode-y">
                <div class="feature-icon wode-icon animated zoomIn"/>
              </div>
            </div>
          </div>
          <div class="main">
            <div class="main-sub animated fadeInRight">
              <h1 class="logo">
                <img src="../common/img/logo.png">
              </h1>
              <div class="content">
                <!-- <h3>让生活有趣&nbsp;&nbsp;有料&nbsp;&nbsp;有想法</h3>
                <p>最火娱乐明星、美食摄影、旅游故事，海量视频看看看不停!</p> -->
                <div class="text">
                  <img
                    src="../common/img/text.png"
                    alt="">
                </div>
                <div
                  class="video-show"
                  v-if="videoInfo.length > 0 ">
                  <div
                    class="video-pc-style"
                    v-for="item in videoInfo"
                    :key="item.id">
                    <video
                      v-if="item"
                      ref="video"
                      id="video"
                      preload="auto"
                      x-webkit-airplay="allow"
                      x5-playsinline=""
                      playsinline=""
                      webkit-playsinline=""
                      disable-video-auto-fullscreen="true"
                      controls
                      controlslist="nodownload"
                      :poster="item.image"
                      :disablePictureInPicture="true"
                      @play="onPlayVideo"
                      @webkitfullscreenchange="onFullscreenchange"
                      @enterpictureinpicture="onEnterpictureinpicture"
                    >
                      <source
                        :src="item.url"
                        type="video/mp4">
                      <source
                        :src="item.url"
                        type="video/ogg">
                      您的浏览器不支持 video 标签
                    </video>
                  </div>
                </div>
              </div>
              <div class="download">
                <a :href="apkUrl">
                  <div class="android-icon">
                    点击下载安卓版APP
                  </div>
                </a>
                <div class="erweima">
                  <img src="../common/img/erweim.png">
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttom">
        版权所有 © 2018 梦与想（杭州）网络科技有限公司
        <br>
        <a
          href="http://beian.miit.gov.cn"
          target="target">备案号：浙ICP备18040813号</a>
        <div style="width:300px;margin:0 auto; padding:20px 0;">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010202001456"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
          >
            <img
              src="../img/icon_police.png"
              style="float:left;">
            <p
              style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
            >浙公网安备 33010202001456号</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import videoItem from '../components/video';
import scroll from '../components/scroll';
import GuideBanner from '../components/guide_banner';
import { fetchList, getNavList, fetchVideoInfo } from '../common/js/fetch.js';
import commen from '../components/commen';
import { throttle } from 'lodash';

export default {
  data() {
    return {
      videoShow: false,
      isLoading: false,
      isBottom: false,
      isHeytapPhone: false,
      topLoading: false,
      topPulling: false,
      count: 10,
      pageLoading: true,
      sessionId: null,
      eveTop: null,
      eveHeight: 0,
      eve: null,
      showGuide: false,
      isMobilePhone: true,
      tabList: [],
      activeIndex: 0,
      tabLoaded: false,
      channelTab: {},
      apkUrl:
        'https://dhfs.heytapdownload.com/userfiles/uploads/apk/Yoli_2.2.3_a62e30e_191115_market_c.apk',
      videoIdList: [
        '415041014022029312',
        '414769219386425344',
        '405643262590722048',
        '416717054759616512',
        '416747253962063872',
        '416158382521589760',
        '416173476337369088',
        '417063343233638400',
        '416321274223730688',
        '415115201814208512',
        '417089866397589504',
      ],
      videoInfo: [],
      refreshTimes:0, //当前刷新总数
      firstRefreshTime:new Date().getTime(), //当前时间戳
    };
  },

  components: {
    videoItem,
    scroll,
    GuideBanner,
  },

  created() {
    this.onScroll = throttle(this.onScroll.bind(this), 500);
  },

  mounted() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.isMobilePhone = true;
    } else {
      this.isMobilePhone = false;
    }
    if (!this.isMobilePhone) {
      this.getPcVideoList();
      return;
    }
    this.getNav();
    window.addEventListener('scroll', this.onScroll);
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      window.addEventListener('scroll', vm.onScroll);
      if (vm.scrollHistory) {
        document.documentElement.scrollTop = document.body.scrollTop =
          vm.scrollHistory;
        console.log(vm.scrollHistory);
      }
    });
  },

  beforeRouteLeave(to, from, next) {
    window.removeEventListener('scroll', this.onScroll);
    this.scrollHistory =
      document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },

  mixins: [commen],

  computed: {
    ...mapState('list', ['offset', 'videoList']),
    toptime() {
      if (this.videoList.length) {
        return this.videoList[0].beHotTime;
      } else {
        return parseInt(Date.now() / 1000, 10);
      }
    },
    bottomtime() {
      const listLength = this.videoList.length;
      if (listLength) {
        return this.videoList[listLength - 1].beHotTime;
      } else {
        return parseInt(Date.now() / 1000, 10);
      }
    },
  },

  methods: {
    dadian() {
      window.oa('send', {
        hitType: 'event',
        eventCategory: 'top_btn',
        eventAction: 'click',
        eventLabel: '/home',
        eventValue: '',
      });
    },

    getPcVideoList() {
      const tasks = [];
      this.videoIdList.forEach(id => {
        fetchVideoInfo({
          docid: id,
          source: 'youli',
        }).then(res => {
          if (this.videoInfo.length >= 3) {
            return;
          }
          const video = res && res.videos[0];
          this.videoInfo.push(video);
        });
      });
    },

    onPlayVideo(event) {
      const currentNode = event.target;
      this.videoEventHandle(currentNode);
    },
    //全屏自动播放
    onFullscreenchange(event) {
      const currentNode = event.target;
      this.videoEventHandle(currentNode);
      currentNode.play();
    },

    //画中画自动播放
    onEnterpictureinpicture(event) {
      const currentNode = event.target;
      this.videoEventHandle(currentNode);
      currentNode.play();
    },
    //播放统一处理
    videoEventHandle(currentNode) {
      const videoNodeList = document.querySelectorAll('video');
      videoNodeList.forEach(el => {
        if (el !== currentNode) {
          el.pause();
        }
      });
    },

    getChannel(obj, index) {
      this.activeIndex = index;
        this.refreshTimes = 0;
        this.firstRefreshTime = new Date().getTime(), //当前时间戳
      this.channelTab = obj;
      this.setStoreState({
        videoList: [],
      });
      this.pageLoading = true;
      this.getList(false);
      this.isLoading = false;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },

    async getNav() {
      this.tabList = JSON.parse(sessionStorage.getItem('m_tabList'))
        ? JSON.parse(sessionStorage.getItem('m_tabList'))
        : [];

      if (this.tabList.length) {
        this.channelTab = this.tabList[0];
        this.getList();
        return;
      }

      await getNavList()
        .then(res => {
          const channelsRes = JSON.parse(res);
          if(channelsRes.code !== 0){
            return;
          }
          this.tabList = channelsRes.data && channelsRes.data.videoChannels;
          this.tabLoaded = true;
          sessionStorage.setItem('m_tabList', JSON.stringify(this.tabList));
          this.channelTab = this.tabList[0];
          this.getList();
        })
        .catch(err => {
          console.log(err);
        });
    },

    onTouchStart(event) {
      if (this.topLoading) return;
      const pageY = event.touches[0].pageY;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) return;

      this.topPulling = true;
      this.topPullDistance = 0;
      this.touchStartY = pageY;
    },

    onTouchMove(event) {
      if (!this.topPulling) return;
      // console.log('touchMove', event)
      const pageY = event.touches[0].pageY;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) return;
      if (pageY < this.touchStartY) {
        console.log('--');
        this.topPulling = false;
        this.topPullDistance = 0;
      } else {
        console.log('++');
        const loadingElemHeight =
          this.$refs.topLoadingElem.offsetHeight +
          this.$refs.videoTabs.offsetHeight;
        this.topPullDistance = Math.min(
          loadingElemHeight,
          pageY - this.touchStartY,
        );
        // console.log(this.topPullDistance)
        if (
          !this.topLoading &&
          this.topPullDistance >= loadingElemHeight / 1.2
        ) {
          console.log('++++');
          this.topLoading = true;
          this.refreshTimes++
          this.getList(false).then(() => {
            this.topLoading = false;
            this.topPulling = false;
            this.topPullDistance = 0;
          });
        }
      }
    },

    onTouchEnd(event) {
      // console.log('touchEnd', event)
      if (!this.topPulling) return;
      if (!this.topLoading) {
        this.topPullDistance = 0;
        this.topPulling = false;
      }
    },

    onScroll() {
      // console.log('on scroll')
      if (this.isLoading || this.pageLoading || this.isBottom) return;
      const docElem = document.documentElement;
      const body = document.body;
      const scrollTop = docElem.scrollTop || body.scrollTop;
      const clientHeight = docElem.clientHeight || body.clientHeight;
      const scrollHeight = docElem.scrollHeight || body.scrollHeight;
      const videoItemHeight = 290;
      // 页面滚动到最后一个视频时，就要开始拉取新的列表了
      if (scrollTop + clientHeight > scrollHeight - videoItemHeight * 2) {
        this.refreshTimes++;
        this.getList();
      }
    },

    setStoreState(state) {
      this.$store.commit('list/SET_STATE', state);
    },

    async getList(fromBottom = true) {
      console.log('get list');
      const c_session = this.getCookie('c_session');
      const c_session_id = this.getCookie('c_session_id');
      const { offset, toptime, bottomtime, videoList } = this;
      const params = {
        fromId: this.channelTab.fromId,
        channel: this.channelTab.channel,
        source: this.channelTab.source,
        offset: fromBottom ? offset : '0',
        session: c_session || '',
        feedssession: c_session_id || '',
        toptime,
        bottomtime,
        use_webp: 1,
        firstRefreshTime:this.firstRefreshTime, //当前时间戳
        refreshTimes:this.refreshTimes //当前刷新总数
      };
      this.isLoading = true;

      return fetchList(params)
        .then(data => {
          this.tabLoaded = true;
          this.pageLoading = false;
          if (!data.feedsList.articles.length && fromBottom) {
            this.isBottom = true;
            this.isLoading = false;
            return;
          }

          this.setStoreState({
            videoList: fromBottom
              ? [...videoList, ...data.feedsList.articles]
              : [...data.feedsList.articles, ...videoList],
            offset: data.feedsList.offset,
          });
          let sessionId = data.sessionId || '';
          let session = data.session || '';

          this.setCookie('c_session_id', sessionId, 45);
          this.setCookie('c_session', session, 45);

          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    },

    videoPlay() {
      this.videoShow = true;
      this.$refs.video.play();
    },

    closeVideo(Obj) {
      this.eveTop = Obj.eveTop;
      this.eveHeight = Obj.eveHeight;
      this.eve = Obj.eve;
    },

    _showGuide() {
      this.showGuide = !this.showGuide;
    },
  },
};
</script>

<style lang='scss' scoped>
.video-box {
  // padding-bottom: px2rem(178);
  position: relative;
  height: 100%;
}

.pc-style {
  .top .main {
    padding: 122px 0 0 442px;
    .main-sub {
      -webkit-animation-duration: 1.5s;
      animation-duration: 1.5s;
    }
  }

  .top .logo {
    width: 328px;
    height: 56px;
    img {
      width: 328px;
      height: 56px;
    }
  }

  .main .content {
    .text {
      width: 636px;
      height: 90px;
      margin: 75px 0 36px;
      img {
        width: 636px;
        height: 90px;
      }
    }
    h3 {
      font-family: ColorFont-Light;
      font-weight: lighter;
      font-size: 50px;
      color: #333333;
      letter-spacing: 0.02px;
      line-height: 54px;
    }
    p {
      font-family: ColorFont-Light;
      opacity: 0.6;
      font-size: 22px;
      color: #333333;
      letter-spacing: 2px;
      margin: 12px 0 30px;
      font-weight: lighter;
    }
  }

  .video-show {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 86px;
    .video-pc-style {
      height: 104px;
      width: 184px;
      border-radius: 8px;
      margin-right: 16px;
      video {
        height: 104px;
        width: 184px;
        border-radius: 8px;
      }
    }
  }
  .download {
    display: flex;
    .android-icon {
      margin: 36px 24px 0 0;
      background: #e74c5c url('../common/img/android.png') no-repeat 30px 18px;
      background-size: 24px;
      width: 243px;
      height: 60px;
      line-height: 60px;
      border-radius: 12px;
      padding-left: 69px;
      box-sizing: border-box;
      font-family: ColorFont-Normal;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0.01px;
    }
    .erweima {
      width: 134px;
      height: 128px;
      img {
        width: 134px;
        height: 128px;
      }
    }
  }
}

.video-list {
  position: relative;
  transition: transform ease 0.1s;
}

.list-item {
  position: relative;
}

.video-style {
  padding-bottom: px2rem(180);
  padding-top: px2rem(132);
  position: relative;
}

.top-loading {
  position: absolute;
  top: px2rem(132);
  left: 0;
  right: 0;
  height: px2rem(178);
  line-height: px2rem(178);
  font-size: px2rem(80);
  text-align: center;
  z-index: -9999;
  .loadingImg {
    width: px2rem(80);
    height: px2rem(80);
  }
}

.bottom-loading {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: center;
  font-size: px2em(80);
  color: #b2b2b2;
  height: px2rem(178);
  line-height: px2rem(178);
  .loadingImg {
    width: px2rem(80);
    height: px2rem(80);
  }
}

.bottom-load2 {
  bottom: 0;
}

.pageLoading {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  .load-icon {
    width: px2rem(80);
    height: px2rem(80);
    background: url('../common/img/loading.gif') no-repeat 0 0 / px2rem(80)
      px2rem(80);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.load-icon {
  width: px2rem(80);
  height: px2rem(80);
  background: url('../common/img/loading.gif') no-repeat 0 0 / px2rem(80)
    px2rem(80);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.open-guide {
  position: fixed;
  top: 0;
  right: px2rem(51);
  width: px2rem(469);
  height: px2rem(323);
  box-sizing: border-box;
  padding: px2rem(102) px2rem(72) px2rem(51);
  color: #fff;
  font-size: px2rem(36);
  letter-spacing: 1px;
  background: url('../common/img/guide_bg.png') no-repeat left top;
  background-size: cover;
  z-index: 1002;
}

.video-tabs {
  box-sizing: border-box;
  font-size: 0;
  padding: 0 3px;
  /* position: relative; */
  top: 0;
  background-color: #fff;
  /* overflow-y: hidden; */
  height: px2rem(132);
  position: fixed;
  z-index: 990;
  width: 100%;
  overflow: hidden;
  z-index: 1005;
}
.video-tabs ul li {
  display: inline-block;
  padding: 0 13px 0 11px;
  line-height: 42px;
  font-size: 17px;
  white-space: nowrap;
  transform: translate3d(0, 0, 0);
  opacity: 1;
}
.video-tabs ul li span {
  display: inline-block;
  box-sizing: border-box;
}
.video-tabs ul {
  white-space: nowrap;
  margin: 0;
  padding: 0;
}
span.active {
  font-weight: 600;
  color: #000;
  border-bottom: 2px solid #000;
}
.m_num {
  position: fixed;
  z-index: 1000000;
  top: 0;
  left: 0;
  background: firebrick;
}
//移动端公网备案样式
#police_beiang {
  height: px2rem(60);
  position: relative;
  text-align: center;
  width: 100%;
  // padding: px2rem(20) 0;
  a {
    height: 100%;
    img {
      height: px2rem(60);
    }
    p {
      font-size: px2rem(30);
      line-height: px2rem(60);
      margin-left: px2rem(20);
    }
  }
}
</style>
